import React from 'react';
import { MdAccountBalanceWallet, MdSwapHoriz } from 'react-icons/md'; // Assurez-vous d'avoir installé react-icons
import { FaDollarSign } from 'react-icons/fa';
import './IconRow.scss';

function IconRow() {
  return (
    <div className='icon-row'>
      <div className='icon-item'>
        <MdAccountBalanceWallet className='icon wallet-icon' />
        <span>My purse</span> {/* Mon portefeuille */}
      </div>
      <div className='icon-item'>
        <MdSwapHoriz className='icon swap-icon' />
        <span>My withdrawal</span> {/* Mon retrait */}
      </div>
      <div className='icon-item'>
        <FaDollarSign className='icon usdt-icon' />
        <span>USDT exchange</span> {/* Échange USDT */}
      </div>
    </div>
  );
}

export default IconRow;
